import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');
import { Board } from './Board';

export const BoardAndDetailContainer = styled.div`
  background: ${colors.white};
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 ${colors.N40A};
  width: ${({ width = 360 }) => `${width}`}px;

  ${Board} {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    width: auto;
  }
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/BoardAndDetailContainer.js